export class GlobalConstants {
    // public  static websiteURL: string = "http://localhost:4200/";
    // public  static websiteURL: string = "https://cyberfinite.com/TruLink-website/";
    public  static websiteURL: string = "https://yodertoter.com/";
    public static apiURL: string = "https://yodertoter.com/yoderadmin/apis/";
    // public static apiURL: string = "https://cyberfinite.com/yoderadmin/apis/";
    // public static apiURL: string = "http://localhost/checking/yoderadmin/apis/";

    public static googleKey: string = "AIzaSyAjaK4K4r90w-1ZOrU_DJibDsaxUnC-bH0";
    public static Stripepkey: string = "pk_live_51TC6bFLvFMA5LcNdhk6ePwciRZVQ1Z06gG3fyCMsYmS7wmxd1yz0jfSDBVwOmn4iof9nmIVF9xuUdk39TAn1VIoO00CO9gaZZU";
    // public static Stripepkey: string = "pk_test_51TC6bML35mdIdO1qhUM6xEupV4QmgKk4DKUmN4VT4vd3DWByLGkxXWLwUH5gQeHAdlSn7gYW57ErYy2B8xqkELXm00B8pr2cGo";
    public static countrycode: string = "+1";

}
